module.exports = __webpack_public_path__ + "roboto-latin-ext-500-italic.woff";